<template>
  <m-base>
    <div class="content">
      <div class="reach">
        <div>
          <h1 class="title">Saved Lists </h1>
        </div>
        <div>Manage your recent saved lists to modify and prepare for checkout.</div>
        <m-save-list-count />
      </div>
    </div>
  </m-base>
</template>

<script>
import MBase from "@/components/layouts/MBase";
import MSaveListCount from "@/components/slc/MSaveListCount";
import utils from "@/assets/utils";

export default {
  components: {
    MBase,
    MSaveListCount
  },
  data() {
    return {
      tabType: -1,
    };
  },
  computed: {},
  created() { },
  methods: {
    tabClick(val) {
      this.tabType = val;
    },
  },
};
</script>

<style scoped lang="scss">
.title {
  text-align: center;
  font-weight: bold;
  color: black;
}

.content {
  display: flex;
  justify-content: center;
  background: white;
}

.reach {
  width: 90%;
  text-align: center;
  padding-top: 50px;
  padding-bottom: 50px;
}

.left-title {
  text-align: left;
}

.right-title {
  text-align: right;
}

.search-text {
  max-width: 500px;
}

.account-select {
  max-width: 200px;
}

.text-danger {
  color: $color-primary !important;
}

.page-class.page-link {
  color: $color-primary !important;
}

.pageinfo {
  font-size: 1.1rem;
  font-weight: bold;
}</style>


// WEBPACK FOOTER //
// src/pages/saveListCount.vue